module.exports = __webpack_public_path__ + "img/card_card.b7ed0973.png";